import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BodyBoard } from 'src/app/components/board/body-board';
import { Subscription } from 'rxjs';
import { setBuyerTypeFilter, showOrderDetails } from 'src/app/redux/actions/order.action';
import { orderStatusConst } from '@shared-logic/orders';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order } from '@shared-logic/orders';
import { OrderValidator, getSumOfTons } from 'src/app/shared/order';

@Component({
  selector: 'app-eraser-body',
  templateUrl: './eraser-body.component.html',
  styleUrls: ['./../../../shared/styles/body-board.scss']
})
export class EraserBodyComponent extends BodyBoard implements OnInit, OnDestroy {
  orders: Order[] = []
  ordersSelected!: Order[];
  isShowDetails: boolean = false;
  orderDetails!: Order;
  ORDER_STATUS_CONTS = orderStatusConst;

  //DIALOGS
  dataModal: any = {
    action: '',
    order: {},
    orders: [], // Added array support
    title: '',
    showModal: false
  };

  // ---- Options ---- \\
  isReload: boolean = false;

  refresh() {
    this.isReload = !this.isReload
  }

  constructor(store: Store<appState>, private orderV: OrderValidator, cdr: ChangeDetectorRef) {
    super(store, cdr);
  }

  ngOnInit(): void {
    this.showDetails$ = this.store.select('order', 'orderBoard', 'showOrderDetails').subscribe(show => {
      this.isShowDetails = show;
    });

    this.details$ = this.store.select('order', 'orderBoard', 'orderDetails').subscribe(order => {
      this.orderDetails = order;
    });

    this.selected$ = this.store.select('order', 'orderBoard', 'ordersSelected').subscribe(orders => {
      this.ordersSelected = orders;
    });

    this.buyerTypeSelected$ = this.store.select('order', 'orderBoard', 'buyerType').subscribe(buyerType => {
      this.buyerTypeSelected = buyerType;
    });

    this.setBodySubscription();

    this.rememberEraserOrdersOfLocalStorage();
  }

  ngOnDestroy(): void {
    this.setBodyUnsubscription();
  }

  setBuyerType(identificator: string) {
    this.store.dispatch(setBuyerTypeFilter({ buyerType: identificator }));
  }

  setModal(event: any) {
    this.dataModal = { ...event }; // Ensure new reference to trigger change detection if needed
  }

  applyAction(event: boolean) {
    if (event) { //Press yes in modal
      const ordersToProcess = this.dataModal.orders && this.dataModal.orders.length > 0
        ? this.dataModal.orders
        : [this.dataModal.order];

      if (this.dataModal.action == 'delete') {
        ordersToProcess.forEach((order: Order) => {
          this.orderV.deleteOrderInEraserOrder(order);
        });
      } else if (this.dataModal.action == 'send') {
        ordersToProcess.forEach((order: Order) => {
          // Verify order has valid ID before processing (sanity check)
          if (order && order._id) {
            this.orderV.saveOrder(order, this.user);
            this.orderV.deleteOrderInEraserOrder(order);
          }
        });
      }
      this.rememberEraserOrdersOfLocalStorage();

    }

    // Always close modal
    this.dataModal = {
      ...this.dataModal,
      showModal: false,
      action: '',
      orders: [],
      order: {}
    };

    this.rememberEraserOrdersOfLocalStorage();
    this.refresh();
  }

  closeSlide() {
    this.store.dispatch(showOrderDetails({ show: false }));
  }

  rememberEraserOrdersOfLocalStorage() {
    this.orders = [...this.orderV.getEraserOrders()];
  }

  getQuantOfTons(orders: Order[]) {
    return getSumOfTons(orders);
  }
}